import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import Icon from '@components/Icon/Icon';

export type VariantType = 'primary' | 'secondary';

interface StatusPillProps {
  name?: string | undefined;
  color: string | null | undefined;
  variant?: VariantType;
  height?: number;
}

function StatusPill({
  name,
  color,
  variant = 'primary',
  height,
}: StatusPillProps) {
  const { palette } = useTheme();
  return (
    <>
      <Chip
        icon={
          variant === 'secondary' ? (
            <Icon
              className="chipIcon"
              color={color ?? undefined}
              name="circle"
              size="2xs"
              type="fas"
              style={{ fontSize: '0.625em !important' }}
            />
          ) : undefined
        }
        label={name}
        sx={{
          backgroundColor: variant === 'primary' ? color : undefined,
          color:
            variant === 'primary'
              ? palette.primary.contrastText
              : palette.text.primary,
          cursor: 'inherit',
          ...(height && {
            height: `${height}px`,
          }),
        }}
        size="small"
      />
    </>
  );
}

export default StatusPill;
export { type StatusPillProps };
